import { computed, ref } from "vue";
import { SslCertificateObject } from "@shared/types/common";
import { defineStore } from "pinia";

export const useCnameStore = defineStore("cname", () => {
  // State
  const _sslList = ref<SslCertificateObject[]>([]);
  const _isSslListLoaded = ref(false);

  // Getters
  const sslList = computed(() => _sslList.value);
  const isSslListLoaded = computed(() => _isSslListLoaded.value);

  // Actions
  const setSslList = (newSslList: SslCertificateObject[]) => {
    _sslList.value = newSslList;
  };

  const markSslListLoaded = () => {
    _isSslListLoaded.value = true;
  };

  const pushToSslList = (sslItem: SslCertificateObject) => {
    _sslList.value.push(sslItem);
  };

  const updateSslItemByIndex = (
    sslItem: SslCertificateObject,
    indexOfSslToUpdate: number,
  ) => {
    _sslList.value[indexOfSslToUpdate] = sslItem;
  };

  return {
    sslList,
    isSslListLoaded,
    setSslList,
    markSslListLoaded,
    pushToSslList,
    updateSslItemByIndex,
  };
});
